module.exports = __webpack_public_path__ + "img/item-2.04cd75e6.jpeg";